// extracted by mini-css-extract-plugin
export default {"tableRow":"style__tableRow___rk8lY","underline":"style__underline___1XAm4","wrapper":"style__wrapper___14lUE"};